export default "__VITE_ASSET__120c6603__"